export default class LanguageEntry {
    constructor(id, label) {
        this.id = id;
        this.label = label;
    }
}